/** Event groups (from apps/crm_events/schemas/event_types.yaml) → concrete event type names. */
export const EVENT_GROUP_TO_TYPES: Record<string, string[]> = {
  ahoy_email: ['ahoy_email_sent', 'ahoy_email_received'],
};

/** Per-kind empty-state display labels (UD-D5: honest absence — always show a real value or dash). */
export const EMPTY_LABELS = {
  property: '—',
  association: '—',
  association_count: '0',
  entity_count: '0',
  last_event: '—',
  last_property_update: 'Never updated',
  computed: '—',
} as const;
